import { FC, PropsWithChildren } from 'react'

import { Header } from './header'

export const Layout: FC<PropsWithChildren<{ stickyHeader?: boolean }>> = ({
  children,
  stickyHeader,
}) => (
  <>
    <Header isFluid isSticky={stickyHeader} />
    {children}
  </>
)
